import src from "IMAGE";
export default { src, width: 84, height: 99, blurWidth: 0, blurHeight: 0};
